import logo from './asset/vmf-logo.webp'
import logo2 from './asset/logo-2.webp'
import logo3 from './asset/logo-3.webp'
import logo4 from './asset/logo-4.webp'
import logo5 from './asset/logo-5.webp'
import logo6 from './asset/logo-6.webp'
import logo7 from './asset/logo-7.webp'

import charity1 from './asset/charity-1.webp'
import charity2 from './asset/charity-2.webp'

import g1 from './asset/blago/gala/g-1.webp'
import g2 from './asset/blago/gala/g-2.webp'
import g3 from './asset/blago/gala/g-3.webp'
import g4 from './asset/blago/gala/g-4.webp'
import g5 from './asset/blago/gala/g-5.webp'
import g6 from './asset/blago/gala/g-6.webp'
import g7 from './asset/blago/gala/g-7.webp'
import g8 from './asset/blago/gala/g-8.webp'

import n1 from './asset/blago/noisy/n1.webp'
import n2 from './asset/blago/noisy/n2.webp'
import n3 from './asset/blago/noisy/n3.webp'
import n4 from './asset/blago/noisy/n4.webp'
import n5 from './asset/blago/noisy/n5.webp'
import n6 from './asset/blago/noisy/n6.webp'
import n7 from './asset/blago/noisy/n7.webp'
import n8 from './asset/blago/noisy/n8.webp'


import k1 from './asset/blago/kons/k1.webp'
import k2 from './asset/blago/kons/k2.webp'
import k3 from './asset/blago/kons/k3.webp'
import k4 from './asset/blago/kons/k4.webp'
import k5 from './asset/blago/kons/k5.webp'
import k6 from './asset/blago/kons/k6.webp'
import k7 from './asset/blago/kons/k7.webp'

import y1 from './asset/blago/year/y1.webp'
import y2 from './asset/blago/year/y2.webp'
import y3 from './asset/blago/year/y3.webp'
import y4 from './asset/blago/year/y4.webp'
import y5 from './asset/blago/year/y5.webp'
import y6 from './asset/blago/year/y6.webp'
import y7 from './asset/blago/year/y7.webp'
import y8 from './asset/blago/year/y8.webp'

import f1 from './asset/blago/five/f1.webp'
import f2 from './asset/blago/five/f2.webp'
import f3 from './asset/blago/five/f3.webp'
import f4 from './asset/blago/five/f4.webp'
import f5 from './asset/blago/five/f5.webp'
import f6 from './asset/blago/five/f6.webp'
import f7 from './asset/blago/five/f7.webp'
import f8 from './asset/blago/five/f8.webp'

import w1 from './asset/blago/woman/w1.webp'

export const CharityArr = {
  'festival' : {
    title: 'Второй всеканадский молодёжный фестиваль',
    link: 'festival',
    info: ['21 сентября 2019 года Детский Центр и его выпускники приняли участие во втором всеканадском молодёжном фестивале. Подробности — в статье Виктории Христовой, газета «Деловой Монреаль».'],
    photos: [],
    photosv: charity1,
    photo: logo,
    videos: []
  },
  'gala': {
    title: 'Русский Гала Бал 2019',
    link: 'gala',
    info: ['1 марта наш Детский Центр провёл третий Благотворительный Русский Гала Бал. Более 230 гостей собрались в зале торжеств Le Windsor посмотреть великолепные выступления воспитанников «Мечты», а также приглашённых певцов и танцоров.', `Читайте также великолепную статью Виктории Христовой в газете <a href="https://www.wemontreal.com/i-gryanul-bal/">Деловой Монреаль</a>`],
    photos: [g1, g2, g3, g4, g5, g6, g7, g8],
    photosv: charity2,
    photo: logo2,
    videos: ['https://www.youtube.com/watch?v=p7OKMKxJAbA', 'https://www.youtube.com/watch?v=I61tr5SS-Mc', 'https://www.youtube.com/watch?v=gOtm4SL7tT4']
  },
  'noisy': {
    title: 'Средь шумного бала',
    link: 'noisy',
    info: ['В пятницу, 20 апреля, прошел восьмой Благотворительный вечер Детского центра «Мечта».', 'На этот раз, как и в прошлом году, он состоялся в форме Весеннего бала, на который в зале Windsor в центре Монреаля собралось около двухсот гостей – коллег, друзей и меценатов.'],
    photos: [n1, n2, n3, n4, n5, n6, n7, n8],
    photosv: null,
    photo: logo3,
    videos: []
  },
  'tradition': {
    title: 'Русский Бал. Возрождение традиции.',
    link: 'tradition',
    info: ['27 января 2017 г. в Генеральном Консульстве России в Монреале прошел Первый Благотворительный Русский Бал. Возрождение традиции.', `<a href="https://mechtacenter.com/wp-content/uploads/2017/03/MECHTA_NG788.jpg">Фоторепортаж Нашей Газеты</a>`],
    photos: [k1,k2,k3,k4,k5,k6,k7],
    photosv: null,
    photo: logo4,
    videos: []
  },
  '15years': {
    title: 'Нам 15 лет',
    link: '15years',
    info: ['15 февраля 2016 года', 'Пятнадцать лет – много это или мало? Для человека – возраст подростка, уже почти взрослого, но полного сомнений и неуверенности в себе. Для школы, тем более русской школы за границей – это более чем серьезный рубеж, который позволяет и подводить итоги, и говорить об уникальном педагогическом опыте, и строить планы.', 'Культурно-образовательный центр для детей и подростков, всем в Монреале известная школа «Мечта» – одна из крупнейших русскоязычных школ в Северной Америке, – может гордиться и совсем маленькими учениками, и выпускниками, которые приводят в «Мечту» уже своих детей, и дружным коллективом, и верными друзьями.',
      'На прошлой неделе на юбилейный благотворительный вечер «Дети – наше будущее» в «Мечте» собрались друзья, чтобы поздравить школу с 15-летием.', 'Вечер, на котором даже офииальная часть была необременительной и теплой – от поздравлений Генконсула Российской Федерации в Монреале Ю.В. Беджаняна, представителей Jean Coutu, Caisse Desjardins и многих других, кого связывают с «Мечтой» годы дружбы и сотрудничества, – до выступлений виртуозных музыкантов и танцоров, фуршета, лотереи и, конечно, общения – удался.', 'Традиционно, средства, вырученные на вечере, распределяются на стипендии для талантливых детей, поддержку семей, оказавшихся в сложной финансовой ситуации, а также на субсидирование бесплатных кружков и секций школы.'],
    photos: [y1, y2, y3, y4, y5, y6, y7, y8],
    photosv: null,
    photo: logo5,
    videos: []
  },
  'fivecharity': {
    title: 'Пятый благотворительный вечер',
    link: 'fivecharity',
    info: ['В ноябре 2014 года прошел V Благотворительный вечер «Дети – наше будущее». Ярчайшим украшением вечера стал концерт Квартета им.Туровского.'],
    photos: [f1, f2, f3, f4, f5, f6, f7, f8],
    photosv: null,
    photo: logo6,
    videos: []
  },
  'womanday': {
    title: '8 марта 2012 — Благотворительный вечер, посвящённый Международному женскому дню',
    link: 'womanday',
    info: ['22 марта Детский Центр «Мечта» в третий раз провел благотворительную акцию «Дети – наше будущее».', 'В программе вечера:', '- выставка художественной студии, которая представила более 150 работ учащихся', '- выставка работ победителей конкурса рисунка, проведенного совместно с фондом «Pierre Beaubien », которая будет передана в дар одному из госпиталей Монреаля', '- праздничный концерт учащихся и педагогов русской школы, посвященный Международному Женскому Дню', '- тираж и коктейль.', 'Собранные средства пойдут на пользу детям.', 'Premier Ministre du Canada M. Stephen Harper, Maire de Montréal M. Gérald Tremblay, Maire de l’arrondissement de CDN – NDG M. Michael Applebaum , Conseillère du district de Côte-des-Neiges M-me Helen Fotopulos прислали приветствия, высоко оценив вклад Детского Центра «Мечта» в развитие канадского общества.', 'На вечер пришли Conseillère du district de Côte-des-Neiges M-me Helen Fotopulos, Membre du comité exécutif, Responsable des communautés d’origines diverses M-me Mary Deros, Responsable aux relations interculturelles M-me Fadima Diallo, Directrice de fondation ‘’Kostitsyn pour enfants’’, Président-fondateur ‘’Fondation Pierre Beaubien’’ M Pierre Beubien, от Le Groupe Jean Coutu – Marie –Hélène Coutu и Gabrielle Coutu, хоккеист Алексей Емелин, Directeur général Desjardins Caisse populaire d’Anjou M Daniel Hébert, Directeur – Services aux entreprises Banque Nationale M François-Xavier Lessard и многие друзья Детского Центра «Мечта».'],
    photos: [],
    photosv: w1,
    photo: logo7,
    videos: []
  },
}
